/**
 * 统一错误处理工具
 */

/**
 * 处理API错误
 * @param {Error} error 错误对象
 * @param {string} defaultMessage 默认错误消息
 * @param {Object} options 选项
 * @param {boolean} options.showMessage 是否显示消息提示
 * @param {boolean} options.logError 是否记录错误日志
 * @returns {string} 错误消息
 */
export function handleApiError(error, defaultMessage = '操作失败', options = {}) {
  const { showMessage = true, logError = true } = options
  
  let errorMessage = defaultMessage
  
  // 提取错误消息
  if (error && error.message) {
    errorMessage = error.message
  } else if (error && error.response && error.response.data) {
    const data = error.response.data
    if (data.message) {
      errorMessage = data.message
    } else if (data.errorMessage) {
      errorMessage = data.errorMessage
    }
  } else if (typeof error === 'string') {
    errorMessage = error
  }
  
  // 记录错误日志
  if (logError) {
    console.error('API错误:', {
      message: errorMessage,
      error: error,
      timestamp: new Date().toISOString()
    })
  }
  
  // 显示错误消息（需要在Vue组件中使用）
  if (showMessage && typeof window !== 'undefined' && window.Vue) {
    window.Vue.prototype.$message && window.Vue.prototype.$message.error(errorMessage)
  }
  
  return errorMessage
}

/**
 * 处理业务错误
 * @param {string} message 错误消息
 * @param {Object} options 选项
 */
export function handleBusinessError(message, options = {}) {
  const { showMessage = true, logError = true } = options
  
  if (logError) {
    console.error('业务错误:', {
      message: message,
      timestamp: new Date().toISOString()
    })
  }
  
  if (showMessage && typeof window !== 'undefined' && window.Vue) {
    window.Vue.prototype.$message && window.Vue.prototype.$message.error(message)
  }
}

/**
 * 安全执行异步函数
 * @param {Function} asyncFn 异步函数
 * @param {string} errorMessage 错误消息
 * @param {Object} options 选项
 * @returns {Promise} 执行结果
 */
export async function safeExecute(asyncFn, errorMessage = '操作失败', options = {}) {
  try {
    return await asyncFn()
  } catch (error) {
    handleApiError(error, errorMessage, options)
    throw error
  }
}

